<template>
  <div class="container print-recipe-medicines">
    <b-overlay :show="loading" opacity="0.99">
      <table
        class="bg-white table-important"
        v-for="table in tables"
        :key="table"
      >
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <div style="page-break-after: always !important">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <img
                        style="
                          height: 80px !important;
                          object-fit: cover !important;
                        "
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div class="ml-5">
                      <b style="font-size: 28px !important">{{
                        String(doctor.name).toUpperCase()
                      }}</b>
                      <div>
                        {{ doctor.professional_class_council_value }}
                      </div>
                    </div>
                    <div>
                      <img
                        width="100px"
                        height="100px"
                        v-if="imgQRCode"
                        :src="imgQRCode"
                      />
                    </div>
                  </div>

                  <!-- IDENTIFICAÇÃO DO EMITENTE -->
                  <div class="identificacao-do-emitente row m-0">
                    <div
                      class="identificacao-do-emitente-left col-md-7"
                      v-if="medicines[0].type_of_recipe_name != 'RECEITA COMUM'"
                    >
                      <h4>IDENTIFICAÇÃO DO EMITENTE</h4>
                      <div><b>Nome:</b> {{ doctor.name }}</div>
                      <div>
                        <b>CRM:</b>
                        {{ doctor.professional_class_council_value }}
                      </div>
                      <div>
                        <b>Endereço:</b> {{ client.address }}
                        {{ client.num_address }}
                      </div>
                      <div>
                        <b>Telefone:</b>
                        {{
                          client.first_phone
                            ? client.first_phone
                            : client.second_phone
                        }}
                      </div>
                      <div>
                        <b>Cidade e UF:</b> {{ client.city }} -
                        {{ client.uf_name }}
                      </div>
                    </div>
                    <div
                      class="identificacao-do-emitente-right col-md-5"
                      v-if="medicines[0].type_of_recipe_name != 'RECEITA COMUM'"
                    >
                      <h2 v-if="tables == 2 && table == 1">1ª VIA</h2>
                      <h4 v-if="tables == 2 && table == 1">
                        {{ medicines[0].type_of_recipe_name }}
                      </h4>
                      <h2 v-if="tables == 2 && table != 1">2ª VIA</h2>
                      <h4 v-if="tables == 2 && table != 1">
                        {{ medicines[0].type_of_recipe_name }}
                      </h4>
                      <h2 v-if="tables != 2">1ª VIA</h2>
                      <h4 v-if="tables != 2">
                        {{ medicines[0].type_of_recipe_name }}
                      </h4>
                      <hr style="width: 100% !important" />
                      <b>ASSINATURA</b>
                    </div>
                  </div>
                  <!-- IDENTIFICAÇÃO DO EMITENTE -->
                </div>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div
                class="content"
                v-show="i.length > 0"
                v-for="(i, k) in separateMedicines"
                :key="k"
              >
                <div v-if="medicines[0].type_of_recipe_name == 'RECEITA COMUM'">
                  <h4>{{ medicines[0].type_of_recipe_name }}</h4>
                </div>
                <div class="d-flex">
                  <p class="m-0">RESIDENTE:</p>
                  <span class="ml-2">{{
                    group_prescription_medicine.resident_name
                  }}</span>
                </div>
                <div class="d-flex mb-5">
                  <p class="m-0">Endereço:</p>
                  {{ client.address }}
                  {{ client.num_address }}
                  {{ client.address ? "," : "" }} {{ client.city }}
                  {{ client.city ? "," : "" }}
                  {{ client.uf_name }}
                </div>
                <div
                  v-for="medicine in i"
                  :key="medicine.id"
                  class="page-break-inside-avoid"
                >
                  <div class="row m-0">
                    <div class="col-md-12 p-0">
                      <div class="row m-0">
                        <div class="col-md-6 p-0 d-flex">
                          <div>
                            <p class="m-0">{{ medicine.name }}</p>
                            <p class="m-0 worksansr">
                              {{
                                String(medicine.active_ingredient_name).length >
                                10
                                  ? `${String(
                                      medicine.active_ingredient_name
                                    ).substring(0, 50)}...`
                                  : medicine.active_ingredient_name
                              }}
                            </p>
                            <small class="m-0 worksansr">
                              {{ handleDuration(medicine.duration) }}
                            </small>
                          </div>
                          <div class="m-0 ml-5">
                            <label class="medicine-text-label"
                              >Instruções</label
                            >
                            <textarea
                              class="form-control medicine-text"
                              v-model="medicine.text"
                            />
                            <span
                              class="medicine-text-span"
                              v-if="medicine.text"
                            >
                              / {{ medicine.text }}</span
                            >
                          </div>
                        </div>
                        <div class="col-md-6 p-0">
                          <div
                            v-if="
                              medicine.medicine_amount_of_times_type == 'SHIFTS'
                            "
                            class="text-thirteen"
                          >
                            <div v-if="medicine.dawn && medicine.dawn_quantity">
                              <span>MADRUGADA:</span>
                              <span>
                                {{
                                  medicine.drops_dawn_quantity
                                    ? `${medicine.drops_dawn_quantity} GOTA(S)`
                                    : medicine.ui_dawn_quantity
                                    ? `${medicine.ui_dawn_quantity} UI`
                                    : medicine.dawn_quantity
                                }}
                                {{
                                  medicine.drops_dawn_quantity
                                    ? ""
                                    : medicine.ui_dawn_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="
                                medicine.morning && medicine.morning_quantity
                              "
                            >
                              <span>MANHÃ:</span>
                              <span>
                                {{
                                  medicine.drops_morning_quantity
                                    ? `${medicine.drops_morning_quantity} GOTA(S)`
                                    : medicine.ui_morning_quantity
                                    ? `${medicine.ui_morning_quantity} UI`
                                    : medicine.morning_quantity
                                }}
                                {{
                                  medicine.drops_morning_quantity
                                    ? ""
                                    : medicine.ui_morning_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="
                                medicine.afternoon &&
                                medicine.afternoon_quantity
                              "
                            >
                              <span>TARDE:</span>
                              <span>
                                {{
                                  medicine.drops_afternoon_quantity
                                    ? `${medicine.drops_afternoon_quantity} GOTA(S)`
                                    : medicine.ui_afternoon_quantity
                                    ? `${medicine.ui_afternoon_quantity} UI`
                                    : medicine.afternoon_quantity
                                }}
                                {{
                                  medicine.drops_afternoon_quantity
                                    ? ""
                                    : medicine.ui_afternoon_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="medicine.night && medicine.night_quantity"
                            >
                              <span>NOITE:</span>
                              <span>
                                {{
                                  medicine.drops_night_quantity
                                    ? `${medicine.drops_night_quantity} GOTA(S)`
                                    : medicine.ui_night_quantity
                                    ? `${medicine.ui_night_quantity} UI`
                                    : medicine.night_quantity
                                }}
                                {{
                                  medicine.drops_night_quantity
                                    ? ""
                                    : medicine.ui_night_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="
                                medicine.shift_5 && medicine.shift_5_quantity
                              "
                            >
                              <span>5º:</span>
                              <span>
                                {{
                                  medicine.drops_shift_5_quantity
                                    ? `${medicine.drops_shift_5_quantity} GOTA(S)`
                                    : medicine.ui_shift_5_quantity
                                    ? `${medicine.ui_shift_5_quantity} UI`
                                    : medicine.shift_5_quantity
                                }}
                                {{
                                  medicine.drops_shift_5_quantity
                                    ? ""
                                    : medicine.ui_shift_5_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="
                                medicine.shift_6 && medicine.shift_6_quantity
                              "
                            >
                              <span>6º:</span>
                              <span>
                                {{
                                  medicine.drops_shift_6_quantity
                                    ? `${medicine.drops_shift_6_quantity} GOTA(S)`
                                    : medicine.ui_shift_6_quantity
                                    ? `${medicine.ui_shift_6_quantity} UI`
                                    : medicine.shift_6_quantity
                                }}
                                {{
                                  medicine.drops_shift_6_quantity
                                    ? ""
                                    : medicine.ui_shift_6_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="
                                medicine.shift_7 && medicine.shift_7_quantity
                              "
                            >
                              <span>7º:</span>
                              <span>
                                {{
                                  medicine.drops_shift_7_quantity
                                    ? `${medicine.drops_shift_7_quantity} GOTA(S)`
                                    : medicine.ui_shift_7_quantity
                                    ? `${medicine.ui_shift_7_quantity} UI`
                                    : medicine.shift_7_quantity
                                }}
                                {{
                                  medicine.drops_shift_7_quantity
                                    ? ""
                                    : medicine.ui_shift_7_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                            <div
                              v-if="
                                medicine.shift_8 && medicine.shift_8_quantity
                              "
                            >
                              <span>8º:</span>
                              <span>
                                {{
                                  medicine.drops_shift_8_quantity
                                    ? `${medicine.drops_shift_8_quantity} GOTA(S)`
                                    : medicine.ui_shift_8_quantity
                                    ? `${medicine.ui_shift_8_quantity} UI`
                                    : medicine.shift_8_quantity
                                }}
                                {{
                                  medicine.drops_shift_8_quantity
                                    ? ""
                                    : medicine.ui_shift_8_quantity
                                    ? ""
                                    : `${medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </span>
                              <small>
                                VIA -
                                {{ medicine.route_of_administration_name }}
                              </small>
                            </div>
                          </div>
                          <div
                            v-if="medicine.frequency == 'SEMANAL'"
                            class="text-thirteen"
                          >
                            Dias da semana:
                            {{ medicine.dom && "DOM" }}
                            {{ medicine.seg && "SEG" }}
                            {{ medicine.ter && "TER" }}
                            {{ medicine.qua && "QUA" }}
                            {{ medicine.qui && "QUI" }}
                            {{ medicine.sex && "SEX" }}
                            {{ medicine.sab && "SAB" }}
                          </div>
                        </div>
                      </div>
                      <span
                        class="text-thirteen"
                        v-if="
                          medicine.medicine_amount_of_times_name &&
                          medicine.medicine_amount_of_times_type != 'SHIFTS'
                        "
                      >
                        {{ medicine.medicine_amount_of_times_name }}:
                      </span>
                      <b
                        v-if="
                          medicine.medicine_amount_of_times_type == 'DAY' ||
                          medicine.frequency == 'EVENTUAL'
                        "
                      >
                        {{
                          `${
                            medicine.drops
                              ? `${medicine.drops} GOTA(S)`
                              : medicine.ui
                              ? `${medicine.ui} UI`
                              : medicine.quantity
                          } ${
                            medicine.drops
                              ? ""
                              : medicine.ui
                              ? ""
                              : `- ${medicine.unit_of_measurement_abbreviation} (S)`
                          }`
                        }}
                      </b>
                      <small>
                        VIA -
                        {{ medicine.route_of_administration_name }}
                      </small>
                      <div
                        class="legends worksansr"
                        v-if="medicine.instruction"
                      >
                        Instrução: {{ medicine.instruction }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="footer">
                <div class="identificacao-do-comprador row m-0">
                  <div
                    class="identificacao-do-comprador-left col-md-7"
                    v-show="medicines[0].type_of_recipe_name != 'RECEITA COMUM'"
                  >
                    <h5 class="text-center m-0">IDENTIFICAÇÃO DO COMPRADOR</h5>
                    <div class="text-left"><b>Nome:</b></div>
                    <div class="text-left"><b>RG:</b></div>
                    <div class="text-left"><b>Endereço:</b></div>
                    <div class="text-left"><b>Telefone:</b></div>
                    <div class="text-left"><b>Cidade e UF:</b></div>
                  </div>
                  <div
                    class="identificacao-do-comprador-right col-md-5"
                    v-show="medicines[0].type_of_recipe_name != 'RECEITA COMUM'"
                  >
                    <h5 class="text-center m-0">IDENTIFICAÇÃO DO FORNECEDOR</h5>
                    <hr />
                    <div class="text-center">
                      <b style="font-size: 14px !important">DATA</b>
                    </div>
                    <hr />
                    <div class="text-center">
                      <b style="font-size: 14px !important"
                        >ASSINATURA DO FARMACÊUTICO</b
                      >
                    </div>
                  </div>
                  <div class="identificacao-do-comprador-bottom col-md-12">
                    <span>Atendimento realizado na Plataforma</span>
                    <img
                      width="150px"
                      height="30px"
                      :src="require('../../../assets/logo.png')"
                    />
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorsMessages class="mt-5" :errors="errors" />
      <v-btn class="mt-5 btn-print float-right" @click="handlePrint"
        ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
      >
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatDate } from "../../../lib/format";

import { userData } from "../../../lib/functions";

import QRCode from "qrcode";

import moment from "moment";

export default {
  name: "Recipe",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      tables: [],

      medicines: [],

      separateMedicines: [],

      rest_home_name: "",

      client: {},
      doctor: {},
      resident: {},
      group_prescription_medicine: {},

      doctor_id: "",
      group_prescription_medicine_id: "",
      prescription_medicine_id: [],

      rest_home_logo_url: null,

      imgQRCode: null,

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,

    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },

    separate(base, max) {
      let result = [[]];
      let group = 0;

      for (let indice = 0; indice < base.length; indice++) {
        if (result[group] === undefined) {
          result[group] = [];
        }

        result[group].push(base[indice]);

        if ((indice + 1) % max === 0) {
          group = group + 1;
        }
      }

      return result;
    },

    async retrieve() {
      let {
        doctor_id,
        group_prescription_medicine_id,
        prescription_medicine_id,
      } = routes.currentRoute.params;

      if (
        !doctor_id ||
        !group_prescription_medicine_id ||
        !prescription_medicine_id
      ) {
        routes.push({ name: "dashboard" });
        return;
      }

      this.doctor_id = doctor_id;
      this.group_prescription_medicine_id = group_prescription_medicine_id;
      this.prescription_medicine_id = prescription_medicine_id.split(",");

      let {
        user: { rest_home_name, logo_url },
      } = userData();

      this.rest_home_name = rest_home_name;
      this.rest_home_logo_url = logo_url;

      await this.getClient();
      await this.getDoctor();
      await this.get();
    },

    async getClient() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/path");

        const { error, errors, client } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.client = client;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getDoctor() {
      try {
        this.loading = true;

        let params = { id: this.doctor_id };

        const response = await api.get("/rest-home/user/get", { params });

        const { error, errors, user } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.doctor = user;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async get() {
      try {
        this.loading = true;

        let params = {
          group_prescription_medicine_id: this.group_prescription_medicine_id,
          prescription_medicine_id: this.prescription_medicine_id,
        };

        const response = await api.get(
          "/rest-home/resident/doctor-recipe/print",
          { params }
        );

        const { error, errors, group_prescription_medicine, medicines } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.group_prescription_medicine = group_prescription_medicine;

          this.medicines = medicines;

          let max = medicines[0].type_of_recipe_name == "RECEITA COMUM" ? 8 : 8;

          this.separateMedicines = this.separate(medicines, max);

          this.tables =
            medicines[0].type_of_recipe_name == "RECEITA COMUM" ? 1 : 2;

          setTimeout(() => {
            let headers = document.getElementsByClassName("header-space");

            for (let i = 0; i < headers.length; i++) {
              if (medicines[0].type_of_recipe_name == "RECEITA COMUM") {
                headers[i].classList.add("header-space-comum");
              } else {
                headers[i].classList.add("header-controle-especial");
              }
            }
          }, 1000);
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      window.print();
    },

    async generateQRCode() {
      try {
        this.loading = true;

        let {
          client: { id: rest_home_id },
          group_prescription_medicine_id,
          prescription_medicine_id,
          doctor_id,
        } = this;

        let _this = this;

        let prescription_medicine_ids = String(
          prescription_medicine_id
        ).slice();

        let codeQRCode = `${crypto.randomUUID()}-${moment().format("HHmmss")},`;

        let url = `https://portal.sistemaclin.com.br/verify/recipe/${rest_home_id}/${group_prescription_medicine_id}/${prescription_medicine_ids}/${doctor_id}/${codeQRCode}`;

        QRCode.toDataURL(url)
          .then((url) => (_this.imgQRCode = url))
          .catch((err) => console.error(err));

        let data = {
          group_prescription_medicine_id,
          prescription_medicine_ids: prescription_medicine_id,
          doctor_id,
          qrCode: codeQRCode,
        };

        await api.post(
          "/rest-home/group-prescription-medicine/generate-qrcode-pdf-recipe",
          data
        );

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.print-recipe-medicines .identificacao-do-emitente-left {
  border: solid 3px #000;
  padding: 2px !important;
  box-sizing: border-box;
}

.print-recipe-medicines .identificacao-do-emitente-left h4 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  text-align: center !important;
}

.print-recipe-medicines .identificacao-do-emitente-right {
  text-align: center !important;
}

.print-recipe-medicines .identificacao-do-comprador-left,
.print-recipe-medicines .identificacao-do-comprador-right {
  border: solid 3px #000;
  padding: 2px !important;
  box-sizing: border-box;
}
.print-recipe-medicines .identificacao-do-comprador-bottom {
  text-align: center;
  padding: 0;
}

.print-recipe-medicines .header {
  display: block !important;
}

.print-recipe-medicines .footer {
  display: block !important;
}

.print-recipe-medicines .header-space-comum {
  height: 100px;
}

.print-recipe-medicines .header-space-controle-especial {
  height: 280px;
}

.print-recipe-medicines .footer,
.print-recipe-medicines .footer-space {
  height: 200px;
}

.print-recipe-medicines table,
.print-recipe-medicines td,
.print-recipe-medicines th,
.print-recipe-medicines tfoot {
  width: 100% !important;
  cursor: auto !important;
}

.print-recipe-medicines .header {
  position: fixed;
  top: 0;
}

.print-recipe-medicines .table-important {
  width: 100% !important;
  cursor: auto !important;
}

.print-recipe-medicines .medicine-text-span {
  display: none;
}

.print-recipe-medicines .medicine-text-span-not-see {
  display: none;
}

.print-recipe-medicines .logo {
  height: 50px;
  object-fit: contain;
}
.print-recipe-medicines .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.print-recipe-medicines .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  @page {
    size: 0;
  }

  .print-recipe-medicines .identificacao-do-emitente-left {
    width: 60% !important;
  }

  .print-recipe-medicines .identificacao-do-emitente-right {
    width: 40% !important;
  }

  .print-recipe-medicines .identificacao-do-comprador-left {
    width: 60% !important;
  }

  .print-recipe-medicines .identificacao-do-comprador-right {
    width: 40% !important;
  }

  .print-recipe-medicines {
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    box-sizing: border-box !important;
  }

  .print-recipe-medicines .table-important {
    page-break-before: always !important;
    page-break-inside: avoid !important;
  }

  .print-recipe-medicines .footer {
    position: fixed;
    bottom: 0;
    /* left: 0;
    right: 0; */
    width: 92% !important;
    max-width: 100% !important;
  }

  .print-recipe-medicines .content {
    page-break-before: always !important;
  }

  .print-recipe-medicines .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-recipe-medicines .medicine-text {
    border: 0 !important;
    resize: none !important;
  }

  .print-recipe-medicines .medicine-text-span {
    display: block;
    font-weight: normal !important;
  }

  .print-recipe-medicines .medicine-text-label {
    display: none;
  }

  .print-recipe-medicines .medicine-text {
    display: none;
  }

  .print-recipe-medicines button {
    display: none;
  }

  .print-recipe-medicines .table-important {
    margin: 10px !important;
  }
}
</style>